module.exports = __webpack_public_path__ + "assets/macbookPreview-1x.1ed67511d74064f4ae2f6fe71bf7a1a1e7e1a6442555aaf26768222b09607fe2.png";